import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const ImagesProvider = (props) => {
  const api = new API();
  const [imageTableFilter, setImageTableFilter] = useState({
    page: 1,
    limit: 100,
  })
  const [imageList, setImageList] = useState([]);
  const [imageListLoader, setImageListLoader] = useState(false);
  const [imageFile, setImageFile] = useState({});
  const [imageUploadLoader, setImageUploadLoader] = useState(false);
  const fetchImageList = async () => {
    setImageListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("wordupload/imageslist", {...imageTableFilter}, (err, res) => {
        if (res?.data?.status === 200) {
          setImageList(res?.data?.data);
        } else {
          setImageList([]);
        }
        setImageListLoader(false);
      }));
  }

  const fileMove = () => {
    setImageUploadLoader(true);
    // localStorage.getItem("rxdx_admin_login") === "true" 
    console.log("imageFile",imageFile)
    const formData = new FormData();
    formData.append("image", imageFile);
      (api.create("wordupload/uploads", formData, (err, res) => {
        if (res?.data?.status === 200) {
          fetchImageList();
          setImageFile({});
          document.getElementById("excelFile1").value = "";
          setImageUploadLoader(false);
        } else {
          setImageUploadLoader(false);
        }
      }));
  }
   return (
    <Context.Provider value={{
      ...props,
      imageTableFilter, setImageTableFilter,
      imageList, setImageList,
      imageListLoader, setImageListLoader,
      fetchImageList,
      imageFile, setImageFile,
      fileMove,
      imageUploadLoader, setImageUploadLoader
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default ImagesProvider;

